import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
// @ts-ignore
import ReactFlagsSelect from "react-flags-select";
import { getLanguageSwitcherService } from "../../services/language-switcher.service";
import countryFlagLabel from "../../assets/json/country_flag.json";
import { getLocalStorageService } from "../../services/local-storage.service";

const ChangeLanguage = styled.div`
  width: 100%;
  color: ${(props) => props.theme.textColor};
  position: relative;
  display: flex;
  border-radius: 4px;

  .menu-flags-button {
    border: none;
    background: ${(props) => props.theme.backgroundTransparentWhite};
    padding: 0 10px 0 4px;
  }

  .ReactFlagsSelect-module_flagsSelect__2pfa2 {
    padding-bottom: 0;

    ul {
      max-height: 200px;
    }
  }

  @media screen and (min-width: 769px) {
    &:hover {
      .languages {
        display: block;
      }
    }
  }
`;

const Switcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (countryCode: string) => {
    i18n.changeLanguage(
      getLanguageSwitcherService().localeForCountryCode(countryCode)
    );
    getLocalStorageService().preferredLanguageCookie = countryCode;
  };

  const selectedCountryCode = getLanguageSwitcherService().countryCodeForLocale(
    i18n.language
  );

  const countries = getLanguageSwitcherService().switcherData(
    i18n.options.supportedLngs!
  );

  return (
    <ChangeLanguage data-test="changeLanguage">
      <ReactFlagsSelect
        selectButtonClassName={"menu-flags-button"}
        selected={selectedCountryCode}
        countries={countries}
        showSecondarySelectedLabel={false}
        showSelectedLabel={false}
        onSelect={(code: string) => changeLanguage(code)}
        alignOptionsToRight={true}
        fullWidth={false}
        customLabels={countryFlagLabel}
        optionsSize={14}
      />
    </ChangeLanguage>
  );
};
export const LanguageSwitcher = memo(Switcher);
